import OperatorService from "@/api/services/operator.service";

const TariffService = {
  getList() {
    return OperatorService.get(`/tariffs`);
  },

  getAvailableTariffs() {
    return OperatorService.get(`/cameras/available-tariffs`);
  },

  get(id) {
    return OperatorService.get(`/tariffs/${id}`);
  },

  update(id, tarrif) {
    return OperatorService.put(`/tariffs/${id}`, tarrif);
  },

  create(tarrif) {
    return OperatorService.post(`/tariffs`, tarrif);
  },
};

export default TariffService;
